const testimonials = [
  {
    quote:
      "Rydey has completely transformed how we manage employee transportation at Network18. Before, coordinating cabs for our broadcast teams — especially for early morning and late-night shifts — was a constant headache. Since partnering with Rydey, everything runs on autopilot. Employees receive timely SMS alerts, vehicles are always on time, and the corporate dashboard gives us full visibility without a single phone call. Truly a reliable partner for a fast-paced media environment.",
    name: "Mr. Balachandran N.",
    role: "Manager Operations",
    company: "Network18 Broadcast Limited",
    initials: "BN",
  },
  {
    quote:
      "As a data analytics firm, we value precision — and that's exactly what Rydey delivers. The automated shift-based scheduling means our team members are never waiting, never anxious about their commute. The billing is transparent, GST-compliant, and reaches us without any follow-up needed. What impressed me most is how Rydey scaled their service seamlessly as our headcount grew. They feel less like a vendor and more like an extension of our operations team.",
    name: "Vishnu Vijayakumar",
    role: "Manager Administration",
    company: "Varahe Analytics Pvt Ltd",
    initials: "VV",
  },
  {
    quote:
      "Managing facilities for a technology company means employee safety and punctuality are non-negotiable. Rydey checks every box — police-verified drivers, GPS-tracked vehicles, and a responsive support team that actually picks up the phone. The Innova Crysta service for our senior executives and client pickups has been particularly impressive. I've recommended Rydey to several peers in the Technopark ecosystem without hesitation. They deliver exactly what they promise.",
    name: "Shaik Abdul Mehthab",
    role: "Facilities Manager",
    company: "Experion Technologies Pvt Ltd",
    initials: "SM",
  },
];

import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  return (
    <section className="section-pad bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-14 reveal">
          <div className="eyebrow mb-4">Trusted By Corporates</div>
          <h2 className="headline text-[34px] md:text-[44px]">
            What our partners say about us.
          </h2>
          <p className="mt-5 text-slate-600 text-[16px] leading-relaxed">
            Real words from the operations, admin, and facilities leaders who count on
            Rydey every working day across Kerala's corporate ecosystem.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} {...t} delay={i * 0.08} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ quote, name, role, company, initials, delay }) {
  return (
    <div
      data-testid="testimonial-card"
      className="relative p-7 rounded-2xl bg-[#f6f7fb] border border-slate-200 card-elevate reveal flex flex-col"
      style={{ transitionDelay: `${delay}s` }}
    >
      <Quote className="text-[#F5A623]/40 absolute top-5 right-5" size={36} />

      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={14} className="fill-[#F5A623] text-[#F5A623]" />
        ))}
      </div>

      <p className="text-slate-700 text-[14.5px] leading-relaxed flex-1">"{quote}"</p>

      <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-[#0D1B40] text-[#F5A623] flex items-center justify-center font-bold text-[14px] shrink-0">
          {initials}
        </div>
        <div className="min-w-0">
          <div className="font-bold text-[#0D1B40] text-[14px] leading-tight">{name}</div>
          <div className="text-slate-500 text-[12.5px] leading-snug">{role}</div>
          <div className="text-[#F5A623] text-[12px] font-semibold mt-0.5 truncate">{company}</div>
        </div>
      </div>
    </div>
  );
}
